import React from 'react'
import SystemLogger from '../../Services/SystemLogger'

export class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props)
		this.state = { hasError: false }
	}

	static getDerivedStateFromError() {
		return { hasError: true }
	}

	componentDidCatch(error, errorInfo) {
		SystemLogger.logEvent('error', 'react-render-error', {
			level: 'error',
			message: error?.message,
			data: {
				stack: error?.stack,
				componentStack: errorInfo?.componentStack,
			},
		})
	}

	render() {
		if (this.state.hasError) {
			return (
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						justifyContent: 'center',
						height: '100vh',
						textAlign: 'center',
						padding: 24,
					}}
				>
					<p style={{ fontSize: 18, marginBottom: 16 }}>
						Произошла ошибка. Попробуйте обновить страницу.
					</p>
					<button className='ContentButton' onClick={() => window.location.reload()}>
						Обновить страницу
					</button>
				</div>
			)
		}

		return this.props.children
	}
}

export default ErrorBoundary
